import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { ToastrService } from 'ngx-toastr';
import { authConfig } from '../auth/models/auth.config';
import { AuthService } from '../auth/services/auth.service';
import { DefaultResponse } from '../models/DefaultResponse';
import { AppInsightsService } from './app-insights.service';

@Injectable({
  providedIn: 'root',
})
export class ConvivaErrorHandlingService {
  constructor(
    private toastr: ToastrService,
    private router: Router,
    private authService: AuthService,
    private oauthService: OAuthService,
    private appInsightsService: AppInsightsService) { this.configure(); }

  private configure() {
    this.oauthService.configure(authConfig);
  }

  async handleError(error: any) {

    if (error instanceof HttpErrorResponse) {
      let nomeMetodo = "";
      const parts = error.url?.split('?');

      if (parts != undefined) {
        const lastSlashIndex = parts[0].lastIndexOf('/');
        nomeMetodo = parts[0].substring(lastSlashIndex + 1);
      }

      if (error.error && error.error.message) {
        this.toastr.error(error.error.message, 'Erro');
        return;
      }

      if (error.status == 0) {
        this.toastr.error('Não foi possivel se conectar com o servidor.', nomeMetodo);
        return;
      }

      if (error.status == 401) {
        const url = (error.url ?? '').toLowerCase();
        const isSedOrIdpOrDiario =
          url.includes('/credenciais') ||
          url.includes('idpsp') ||
          url.includes('diarioclasse');

        // Para APIs Conviva, o interceptor já tenta refresh+retry. Se ainda chegou aqui como 401,
        // o interceptor normalmente já terá direcionado para logout. Evitar "logout em cascata"
        // e duplicação de mensagens neste handler.
        if (!isSedOrIdpOrDiario) {
          this.toastr.error('Sua sessão expirou. Tente novamente.', 'CONVIVA');
          return;
        }

        // Para SED/IdP/Diário, manter comportamento atual (sem token Conviva válido não há fluxo a recuperar).
        this.toastr.error('Sua sessão expirou, por favor efetue o login novamente.', 'CONVIVA');
        this.toastr.error('Em 5 segundos iremos te redirecionar para o login.', 'CONVIVA');
        this.authService.cleanStorageMasp();
        this.authService.cleanStorageGovBr();
        this.authService.cleanStorageConviva();
        this.router.navigate(['/logout']);
        return;
      }

      this.toastr.error('Ocorreu um erro.', 'Erro');

    } else {
      console.error('Ocorreu um erro:', error);
      this.toastr.error('Ocorreu um erro.', 'Erro');
    }
  }

  async handleResultError(error: any): Promise<DefaultResponse> {
    const result: DefaultResponse = <DefaultResponse>{};
    result.isSucess = false;

    if (error instanceof HttpErrorResponse) {
      let nomeMetodo = "";
      const parts = error.url?.split('?');

      if (parts != undefined) {
        const lastSlashIndex = parts[0].lastIndexOf('/');
        nomeMetodo = parts[0].substring(lastSlashIndex + 1);
        result.title = nomeMetodo;
      }

      if (error.error && error.error.message) {
        result.message = error.error.message + 'Erro';
        result.data = error;
      }

      if (error.status == 0) {
        result.message = 'Não foi possivel se conectar com o servidor.';
        result.data = error;
      }

      if (error.status == 401) {
        const url = (error.url ?? '').toLowerCase();
        const isSedOrIdpOrDiario =
          url.includes('/credenciais') ||
          url.includes('idpsp') ||
          url.includes('diarioclasse');

        // Para APIs Conviva, o interceptor (request interceptor) é responsável por refresh+retry e eventual logout.
        // Aqui evitamos limpar storage e redirecionar novamente.
        if (!isSedOrIdpOrDiario) {
          result.message = 'Sua sessão expirou. Tente novamente.';
          return result;
        }

        result.message = 'Sua sessão expirou, por favor efetue o login novamente.';

        this.toastr.error('Sua sessão expirou, por favor efetue o login novamente.', 'CONVIVA');
        this.toastr.error('Em 5 segundos iremos te redirecionar para o login.', 'CONVIVA');

        this.authService.cleanStorageMasp();
        this.authService.cleanStorageGovBr();
        this.authService.cleanStorageConviva();
        this.router.navigate(['/login']);
      }
    }
    else {
      result.message = 'Ocorreu um erro:' + error;
      result.data = error;
    }

    this.appInsightsService.trackEvent(result.message!, result);
    this.appInsightsService.trackException(error, 4); //1 = Verbose, 2 = Information, 3 = Warning, 4 = Error, 5 = Critical

    return result;
  }
}
